<template>
  <div class="layout-column">
    <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center pa-2">
      <lx-btn :disabled="isDisabled"
              icon="add_circle"
              :color="compColor.primeColor"
              :iconColor="'white'"
              :tooltip="$t('FORMS_DIVERSE.ADD_NEW_PRE_EXISTING_ILLNESS')"
              :label="$t('FORMS_DIVERSE.ADD_NEW_PRE_EXISTING_ILLNESS')"
              iconSize="21"
              :width="'auto'"
              :height="35"
              classes="text-none"
              @click="addNewItem(path)"
      ></lx-btn>
    </div>

    <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

    <div :key="index" v-for="(item, index) in model"
         class="layout-row pa-0 ma-2"
         :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
         style="border-radius:4px;"
         :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

      <div class="layout-row layout-wrap flex px-4 pt-4">
        <div class="flex-gt-sm-20 flex-100 pl-2 pr-1">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.diagnosedatum'"
                               :ref="path + '.' + index + '.diagnosedatum'"
                               :rules="{required:true, year_must_be_lesser_than_diagnosis:[diagDate],min_value: 1900}"
                               v-slot="{ errors }">
            <lx-numberfield
              :hide-details="!errors || errors.length <= 0"
              :name="path + '.' + index + '.diagnosedatum'"
              :label="$t('FORMS_DIVERSE.PRE_EXISTING_ILLNESS_YEAR_OF_DIAGNOSIS') + ' *'"
              class="mr-1"
              @input="setIcdVersionAfterDate(item)"
              :disabled="isDisabled"
              :dense="denseFields"
              :error-messages="errors[0]"
              v-model="item.diagnosedatum"
              :max-length="4"
            ></lx-numberfield>
          </validation-provider>
        </div>

        <div class="flex-gt-sm-30 flex-100 px-2">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.icd_code'"
                               :ref="path + '.' + index + '.icd_code'"
                               rules="required|icd10_code_auto_complete"
                               v-slot="{ errors }">
            <lx-autocomplete
                :label="$t('FORMS_DIVERSE.ICD_CODE') + ' *'"
                v-model="item.icd_code"
                :error="errors[0]"
                @search-method="getDataForAutocomplete"
                @input="setDiagnosis"
                :setValueOnlyPerChoice="true"
                :disabled="isDisabled"
                :dense="denseFields"
                :index="index"
                :hint="$t('FORMS_DIVERSE.CANCER_DIAGNOSIS_HINT')"
                :persistent_hint="true"
                :results="resultSearchModel">
              <template v-slot="slotProps">
                <div class="layout-row">
                  <div style="width: 100px;border-radius: 4px;" class="mr-2 px-2 white lighten-2 layout-column layout-align-center-center">
                    <h3>
                      <lx-text-highlight :text="slotProps.lineItem.code" :search-string="slotProps.searchText" :color="compColor.prime"></lx-text-highlight>
                    </h3>
                  </div>
                  <div class="flex">
                  <span class="body-2">
                    <lx-text-highlight :text="slotProps.lineItem.description" :search-string="slotProps.searchText" :color="compColor.prime"></lx-text-highlight>
                  </span>
                  </div>
                </div>
              </template>
            </lx-autocomplete>
          </validation-provider>
        </div>

        <div class="flex-gt-sm-50 flex-100 px-2">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.icd_version'"
                               :ref="path + '.' + index + '.icd_version'"
                               rules="required"
                               v-slot="{ errors }">
            <v-select
              :color="compColor.primeColor"
              :label="$t('FORMS_DIVERSE.ICD_CODE_VERSION') + ' *'"
              v-model="item.icd_version"
              :items="Primaertumor_ICD_VersionTypes"
              outlined
              class="mb-2"
              @change="resetICD10Code(index)"
              :disabled="isDisabled"
              :persistent-hint="true"
              :hint="$t('FORMS_DIVERSE.CODE_VERSION_HINT')"
              :dense="denseFields"
              :error-messages="errors[0]"
              :menu-props="{ bottom: true, offsetY: true }"
              :dark="compColor.isInDarkMode">
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on"
                             :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                  <v-list-item-content class="py-0">
                    <label style="cursor:pointer;"
                           :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                           class="lighten-4 text--darken-2">{{ item.text }}</label>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </validation-provider>
        </div>

        <div class="flex-gt-sm-100 flex-100 px-2">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.freitext'"
                               :ref="path + '.' + index + '.freitext'"
                               rules="trim_string"
                               v-slot="{ errors }">
            <long-input
              :color="compColor.primeColor"
              :name="path + '.' + index + '.freitext'"
              :label="$t('FORMS_DIVERSE.ICD_CODE_TEXT')"
              v-model="item.freitext"
              :disabled="isDisabled"
              :dense="denseFields"
              :error="errors[0]"
            ></long-input>
          </validation-provider>
        </div>
      </div>

      <div class="layout-column layout-align-center-center px-3"
           :class="{'grey lighten-2': !compColor.isInDarkMode}"
           :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
        <lx-btn @click="deleteItem(path, index, path + '.' + index + '.freitext')"
                :color="compColor.primeColor"
                :iconColor="'white'"
                iconSize="21"
                :width="35"
                :height="35"
                :disabled="isDisabled" icon="delete_forever"></lx-btn>
      </div>
    </div>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'
import utils from '../../../common/utils'
import LxAutocomplete from '../../lx_auto_complete/LxAutocomplete'

export default {
  name: "FruehereTumorerkrankung",
  mixins: [metaData, utils],
  components: {
    LxAutocomplete
  },
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    path: {
      type: String
    },
    addNewItem: {
      type: Function
    },
    deleteSelectedItem: {
      type: Function
    },
    isDisabled: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    patientId: {
      type: String
    }
  },
  data () {
    return {
      model: [],
      selectedIndexICD10: null,
      Primaertumor_ICD_VersionTypes: null,
      resultSearchModel: {},
    }
  },
  created () {
    this.Primaertumor_ICD_VersionTypes = this.filterVersions('icd10')
  },
  methods: {
    /**
     * Delete selected element of previous diseases and trigger validator for saving
     */
    deleteItem (path, index, field) {
      this.deleteSelectedItem(path, index)
      this.validationRef.fields[field].changed = true
    },

    /**
     * Delete ICD10-code and text after changing version
     *
     * @param index The index of disease-element
     */
    resetICD10Code (index) {
      this.$delete(this.model[index], 'icd_code')
      this.$delete(this.model[index], 'freitext')
    },

    /**
     * Set version per default after date input
     */
    setIcdVersionAfterDate (item) {
      if (item.diagnosedatum) {
        const selectedVersion = this.Primaertumor_ICD_VersionTypes.find((code) => { return code.misdValue === item.diagnosedatum.toString() })

        // version will only be set, if year is part of version-list, else set it on "Sonstige"
        if (selectedVersion) {
          this.$set(item, 'icd_version', selectedVersion.value)
        } else {
          this.$set(item, 'icd_version', this.Primaertumor_ICD_VersionTypes[this.Primaertumor_ICD_VersionTypes.length - 1].value)
        }
      }
    },

    /**
     * Get list of icd10 codes via regex in auto-complete
     *
     * @param data The search string
     * @param index The index of element in diseases array
     */
    getDataForAutocomplete (data, index) {
      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)

      let config = {
        opts: {
          limit: 30
        },
        query: {
          searchValue: data
        }
      }

      // if icd-10 version is set, send it to backend
      const foundVersion = this.Primaertumor_ICD_VersionTypes.find(elem => elem.value === this.model[index].icd_version)

      if (foundVersion?.misdValue) {
        config.query.version = foundVersion.misdValue
      }

      // if selected version is "Sonstige", then use oldest misd-version for request
      if (foundVersion?.value === 'Sonstige') {
        config.query.version = this.Primaertumor_ICD_VersionTypes[this.Primaertumor_ICD_VersionTypes.length - 2].misdValue
      }

      this.$http.get('/icd10?config=' + JSON.stringify(config) + '&filtered=tumor')
          .then(res => {
            this.resultSearchModel = {
              result: res.data.items,
              count: res.data.count,
              version: foundVersion?.value === 'Sonstige' ? 'Sonstige' : res.data.version,
              index: index
            }
          })
          .catch(this.NotifyError)
    },

    /**
     * Set icd10 value via list form auto complete
     *
     * @param data The selected element from list in auto-complete
     * @param index The index of element in diseases array
     */
    setDiagnosis (data, index) {
      if (data && data.code) {
        const foundVersion = this.Primaertumor_ICD_VersionTypes.find(elem => elem.misdValue === this.resultSearchModel.version)
        const version = foundVersion?.value ? foundVersion?.value : this.formsMetaData.ICD10_Version

        this.$set(this.model[index], 'icd_code', data.code)
        this.$set(this.model[index], 'freitext', data.description)
        this.$set(this.model[index], 'icd_version', version)
      } else {
        if (!this.model[index].icd_code || typeof data === 'string' || (this.validationRef.errors  && this.validationRef.errors[this.path + '.' + index + '.icd_code'] && this.validationRef.errors[this.path + '.' + index + '.icd_code'].length > 0)) {
          // nextTick is necessary to trigger watcher in autocomplete on the right way
          this.$nextTick(() => {
            // delete input of icd10, if not selected from result list
            if (typeof data === 'string') this.$set(this.model[index], 'icd_code', null)
          })

          this.$set(this.model[index], 'freitext', undefined)
        }
      }
    }
  },
  computed: {
    diagDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).diagDate : undefined
    },
    deathDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).deathDate : undefined
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
